import React from 'react';
import { Alert } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

/**
 * Warning info bar matching Business Info / ProfileView alert styling (Ant Design).
 */
export default function QuotationInfoAlert({ message, className = '' }) {
  return (
    <div className={`ProfileView_alertContainer Quotation_modalAlert ${className}`.trim()}>
      <Alert
        type="error"
        showIcon={false}
        message={
          <div className="ProfileView_alertIcon">
            <ExclamationCircleFilled style={{ color: '#FAAD14' }} />
            {message}
          </div>
        }
      />
    </div>
  );
}
